<script setup>
import { de } from 'date-fns/locale'
import { setDefaultOptions } from 'date-fns'

setDefaultOptions({ locale: de })

</script>

<template>
  <NuxtLayout>
    <NuxtPage />
  </NuxtLayout>
</template>

<style>
*:not(.no-focus-effect) {
  @apply focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-mustard-200;
}
.no-focus-effect {
  @apply focus:outline-none;
}

ol[data-sonner-toaster] {
  @apply !w-full !max-w-2xl;
}

html {
  scroll-behavior: instant;
  overflow-y: auto;
}

/* Force initial scroll position */
html, body {
  scrollbar-gutter: stable;
  scroll-top: 0 !important;
}

[type="search"]::-webkit-search-decoration,
[type="search"]::-webkit-search-cancel-button {
  appearance: none;
}
</style>
